




import Vue from 'vue'

export default Vue.extend({
  layout: 'blank',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  // lang属性を現在のロケールに連動させる
  head(): { htmlAttrs: { lang: string } } {
    return { htmlAttrs: { lang: this.$i18n.locale } }
  },
  mounted() {
    // bodyにsimpleクラスを追加
    document.body.classList.add('simple')

    // ローディングを非表示にする
    this.$$hideLoading()
  },
})
